const KEY = 'gsorg_theme';

export function getTheme() {
  const saved = localStorage.getItem(KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
    return 'light';
  }
  return 'dark';
}

export function applyTheme(theme) {
  const t = theme === 'light' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', t);
  localStorage.setItem(KEY, t);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', t === 'light' ? '#f8fafc' : '#0a1628');
  }
  return t;
}

export function toggleTheme() {
  const next = getTheme() === 'light' ? 'dark' : 'light';
  return applyTheme(next);
}

export function initTheme() {
  return applyTheme(getTheme());
}
